import React from 'react';
import WarehouseReceiptQuickViewModal from '../WarehouseReceiptQuickViewModal';

// Component that renders all warehouse receipt-related modals
const WarehouseReceiptModals: React.FC = () => {
  return (
    <>
      {/* Quick View Modal is handled directly in the page component */}
      {/* This component is for future modals that might use global state */}
    </>
  );
};

export default WarehouseReceiptModals;

// Export individual components
export {
  WarehouseReceiptQuickViewModal,
};
